export const SERVER_URI = process.env.REACT_APP_SERVER_URI;
export const SERVER_URI_API = process.env.REACT_APP_SERVER_URI_API;
